import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import Logger from 'core/utils/Logger'

export const checkLandingAccess = async () => {
  const url = proxy(`/webservice/197/sp/v4/spJBPPlanningLandingAllowed/call`)

  const [accessToken] = getTokens()
  const headers = new HttpHeaders()

  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  try {
    const response = await Rest.post({ url, headers })

    return {
      isAllowed: Boolean(response?.Data[0].Allowed),
      type: response?.Data[0].LandingType || null,
      landingPage: response?.Data[0].LandingPage || null,
      isWelcomeFlowShown: response?.Data[0].IsWelcomeFlowShown || false,
      isWelcomeFlowEligible: response?.Data[0].IsWelcomeFlowEligible || false,
    }
  } catch (e) {
    Logger.error(e)
    return {
      isAllowed: false,
      type: null,
      landingPage: null,
      isWelcomeFlowShown: false,
      isWelcomeFlowEligible: false,
    }
  }
}
